<template>
  <app-modal v-model="isDialogOpened"
             hide-header
             size="lg"
             @cancel="closeDialog"
  >
    <template #body>
      <ProjectTypeFeatureHeader :shadow-color="PROJECT_TYPE_COLORS.DATAROOM"
                                :illustration="discoverDataroomIllustration"
                                @close="closeDialog"
      >
        <template #title>
          <h3 class="text-deep-purple">{{ $t('common.discover') }}</h3>
          <h1>{{ $t('projects.dialogs.DiscoverDataroomDialog.moduleTitle') }}</h1>
        </template>
      </ProjectTypeFeatureHeader>

      <div class="copyright">
        <CopyrightLink author="fullvector"
                       link="https://fr.freepik.com/vecteurs-libre/salle-serveur-isometrique-centre-donnees-base-donnees-travaillant-projet-commun-travail-equipe-collaboration_4102337.htm"
        />
      </div>
      <div class="features-list">
        <ProjectTypeFeaturesList :features="features" icon-class="text-deep-purple" />
      </div>
    </template>

    <template #footer>
      <v-spacer />
      <AppButton color="white" @click="closeDialog">
        {{$t('common.cancel')}}
      </AppButton>

      <AppButton v-if="canCurrentUserCreateDataroom"
                 color="primary"
                 @click="createDataRoom"
      >
        {{ $t("projects.dialogs.DiscoverDataroomDialog.createDataroom") }}
      </AppButton>
      <AppButton v-else
                 color="primary"
                 @click="requestActivation"
      >
        {{ $t("projects.dialogs.DiscoverDataroomDialog.activate") }}
      </AppButton>
    </template>
  </app-modal>
</template>

<script>
import { mapGetters } from 'vuex'

import discoverDataroomIllustration from '@/assets/img/discover_dataroom.svg'
import AppButton from '@/common/buttons/AppButton.vue'
import CopyrightLink from '@/common/CopyrightLink.vue'
import { dialogMixin } from '@/mixins/dialogMixin'
import { PROJECT_TYPE_COLORS } from '@/projects/dialogs/projectTypeColors'

import ProjectTypeFeatureHeader from '../project-types/ProjectTypeFeatureHeader.vue'
import ProjectTypeFeaturesList from '../project-types/ProjectTypeFeaturesList.vue'

const FEATURES_ICONS = {
  1: 'forum',
  2: 'group',
  3: 'visibility',
}

export default {
  name: 'DiscoverDataroomDialog',
  components: { AppButton, CopyrightLink, ProjectTypeFeatureHeader, ProjectTypeFeaturesList },
  mixins: [dialogMixin],
  data () {
    return {
      PROJECT_TYPE_COLORS,
      discoverDataroomIllustration,
      features: Object.keys(FEATURES_ICONS).map(key => ({
        icon: FEATURES_ICONS[key],
        title: this.$t(`projects.dialogs.DiscoverDataroomDialog.features.${key}.title`),
        description: this.$t(`projects.dialogs.DiscoverDataroomDialog.features.${key}.description`),
      })),
    }
  },
  computed: {
    ...mapGetters('user', ['canCurrentUserCreateDataroom']),
  },
  methods: {
    createDataRoom () {
      this.$emit('createDataroom')
    },
    requestActivation () {
      this.closeDialog()
      this.$emit('requestActivation')
    },
  },
}
</script>

<style scoped lang="scss">
.features-list {
  margin: 0 45px;
  max-width: 600px;
}

@media (max-width: 768px) {
  .features-list {
    margin: 0 20px;
  }
}

.copyright {
  position: absolute;
  right: -20px;
  transform: rotate(-90deg);
}
</style>
